import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RxHamburgerMenu } from 'react-icons/rx'
import { useUserContext } from '../../context/UserContext'
import { signOut } from 'aws-amplify/auth'
import Sidebar from '../../components/Common/Sidebar/Sidebar'
import AdminProfile from '../AdminProfile/AdminProfile'
import MobileSideBar from '../MobileSideBar/MobileSideBar'
import FormInput from '../atoms/Input/Form-Input'
// import './style.css'
import OrderTable from '../OrderTable/OrderTable'
import arrow_up from '../../assets/icons/arrow-up.svg'
import { gql, useQuery } from '@apollo/client';
import { LIST_TRANSACTIONS } from '../../apollo/queries/orders';
import QueriesTable from '../QueriesTable/QueriesTable'
import Pagination from '../Pagination/Pagination'

function AllQueries() {
  const dropdownRef = useRef(null)
  const sidebarRef = useRef(null)
  const { reset } = useUserContext()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const { data: orders, loading } = useQuery(gql(LIST_TRANSACTIONS), {
    variables: {
            limit: 100
        }
    });

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(!isOpen)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setToggle(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [sidebarRef])

  return (
    <div className="w-full h-[100%] flex">
      <Sidebar />
      <div className="admin-dashboard-card-section mx-auto order-section xl:ml-[290px] w-[100%] xl:w-[80%]">
        <div className="w-[90%] lg:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <div className="xl:hidden block" onClick={() => setToggle(!toggle)}>
            <RxHamburgerMenu className="w-5 h-5" />
          </div>
          {toggle && <MobileSideBar toggle={toggle} setToggle={setToggle} />}

          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>
        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] h-[100%] mx-auto">
          <h1 className="admin-dashboard">Queries</h1>
          <div className="md:flex justify-between flex-wrap items-center md:mt-[-50px]">
            <h4 className="status">All Queries</h4>
            <div className="w-[200px] 2xl:w-[250px] relative">
              <div
                className="max-w-sm mx-auto filter p-[6px]  rounded-[60px] "
                style={{ border: '1px solid black' }}
              >
                <select
                  id="countries"
                  className="border-none filter outline-none bg-[#fff] text-gray-900 text-sm rounded-lg mx-auto  block w-[90%] h-[34px]"
                >
                  <option value="today">Today</option>
                </select>
              </div>
            </div>
          </div>
          <div className="mt-10 md:mt-0 overflow-x-scroll tableContainer">
            <QueriesTable />
          </div>
          <Pagination />
        </div>
      </div>
    </div>
  )
}

export default AllQueries
